import dayjs from 'dayjs'
import React from 'react'

import { useBigCalendar } from '../../utils/use-big-calendar'
import { useBigCalencarFormContext } from '../../utils/use-big-calendar-form'
import { capitalizeFirstLetter } from '../../../../../../../../utils'
import { SimpleModal, SimpleModalProps } from '../../../../../../../atoms'

type BigCalendarModalProps = Pick<
  SimpleModalProps['content'],
  'body' | 'footer'
>
export const BigCalendarModal = (content: BigCalendarModalProps) => {
  const { locale } = useBigCalendar()
  const { modalFormProps: modalState, handleOnModalClose } =
    useBigCalencarFormContext()

  return (
    <SimpleModal
      name='big-calendar-modal'
      hasError={false}
      isLoading={false}
      isOpen={Boolean(modalState)}
      onClose={handleOnModalClose}
      content={{
        ...content,
        header: !modalState?.formValues ? null : (
          <div className='font-bold'>
            {modalState?.type === 'cell'
              ? capitalizeFirstLetter(
                  dayjs(modalState.formValues.date)
                    .locale(locale)
                    .format('dddd DD MMMM YYYY'),
                )
              : `${capitalizeFirstLetter(dayjs(modalState.formValues.start).locale(locale).format('dddd DD MMMM YYYY'))} - ${capitalizeFirstLetter(
                  dayjs(modalState.formValues.end)
                    .locale(locale)
                    .format('dddd DD MMMM YYYY'),
                )}
								`}
          </div>
        ),
      }}
    />
  )
}
